var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var DualRowPackageWithDifferentPadGeneratorInteractionModel = require('../dualRowPackageWithDifferentPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var ChipArrayFourSideFlatConcavePadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    DualRowPackageWithDifferentPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(ChipArrayFourSideFlatConcavePadGeneratorInteractionModel, DualRowPackageWithDifferentPadGeneratorInteractionModel);
ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.$class = 'ChipArrayFourSideFlatConcavePadGeneratorInteractionModel';

module.exports = ChipArrayFourSideFlatConcavePadGeneratorInteractionModel;

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.initialize = function() {
    var self = this;

    DualRowPackageWithDifferentPadGeneratorInteractionModel.prototype.initialize.call(this);

    this.oddPadWidthMin = this.shadow("oddPadWidthMin",
        function() {
            return self.data.oddPadWidthMin() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMin(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMin, this.userSettingsModel.distanceUnit
        ]
    );

    this.oddPadWidthMax = this.shadow("oddPadWidthMax",
        function() {
            return self.data.oddPadWidthMax() / self.getUnitFactor();
        },
        function(value) {
            return self.data.oddPadWidthMax(parseFloat(value) * self.getUnitFactor());
        }, [
            self.data.oddPadWidthMax, this.userSettingsModel.distanceUnit
        ]
    );

    this.componentFamily = this.shadow("componentFamily",
        function() {
            return self.data.componentFamily();
        },
        function(value) {
            return self.data.componentFamily(value);
        },
        [self.data.componentFamily]
    );

    this.leadShapeType = this.shadow("leadShapeType",
        function() {
            return self.data.leadShapeType();
        },
        function(value) {
            return self.data.leadShapeType(value);
        },
        [self.data.leadShapeType]
    );
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForComponentFamily = function() {
    var componentFamilyList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE) {
        var c = cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayComponentFamily.FLAT_CONCAVE[t];
        componentFamilyList.push([this.LCLZ(t, c), c]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('componentFamily', 'Component Family'), this.componentFamily, componentFamilyList)];
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForLeadShapeType = function() {
    var leadShapeTypesList = [];

    for (var t in cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayLeadShapeType) {
        var s = cio_datamodel.IpcDataModel.ComponentAttribute.chipArrayLeadShapeType[t];
        leadShapeTypesList.push([this.LCLZ(t, s), s]);
    }

    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('leadShape', 'Lead Shape'), this.leadShapeType, leadShapeTypesList)];
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForPadCount = function() {
    return [PackageGeneratorInspectorConfig.getSelectbox(this.LCLZ('#Pins', '# Pins'), this.horizontalPadCount, [4, 6, 8, 10, 12, 14, 16])];
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForLabel = function(label) {
    return [PackageGeneratorInspectorConfig.getLabel(label)];
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForTerminalLength = function() {
    var normalTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L', this.LCLZ('terminalLength', 'Terminal Length'), false, this.padWidthMin, false, this.padWidthMax, this.userSettingsModel.distanceUnit);
    var oddTerminalLength = PackageGeneratorInspectorConfig.getMinMaxRow('L1', this.LCLZ('oddTerminalLength', 'Odd Terminal Length'), false, this.oddPadWidthMin, false, this.oddPadWidthMax, this.userSettingsModel.distanceUnit);

    return [normalTerminalLength, oddTerminalLength];
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

ChipArrayFourSideFlatConcavePadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];

    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintChipArray4SideFlat));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForOddPadLengthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForOddPadWidthInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForPadGap1InCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForComponentFamily());
    imElements = imElements.concat(this.getInspectorElementForPadCount());
    imElements = imElements.concat(this.getInspectorElementForLeadShapeType());
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForLabel(this.LCLZ('chipArrayNote', '* L1 and b1 are optional.')));
    imElements = imElements.concat(this.getInspectorElementForPitch());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};